<template>
  <div class="head-page" :style="isShowHeader ? '':'padding-top:0px;'">
    <Header :title="$t('exchangeb.title')" v-show="isShowHeader" />
    <div class="withdrawal-box">
      <div class="withdrawal-frm">
        <van-row class="change-item">
          <van-col :span="8"
            ><span @click="clickToshow(true)"
              >{{ fromitem.title
              }}<van-icon name="arrow-down" size="18" /></span
          ></van-col>
          <van-col :span="8" class="txt-center">
            <img src="@/assets/homeicon/icon-3.png" @click="change" />
          </van-col>
          <van-col :span="8" class="txt-right"
            ><span @click="clickToshow(false)"
              >{{ toitem.title }}<van-icon name="arrow-down" size="18" /></span
          ></van-col>
        </van-row>

        <p>
          {{ $t("assets.usenum") }}
          {{ parseFloat(fromitem.balance).toFixed(8) }} {{ fromitem.title }}
        </p>
      </div>
      <div class="withdrawal-frm">
        <van-form @submit="onSubmit">
          <van-cell
            :title="$t('exchangeb.account')"
            :value="accouttype.label"
            @click="showPicker1 = true"
          >
            <template #extra>
              <van-icon name="arrow-down" size="18" />
            </template>
          </van-cell>

          <van-cell :title="$t('withdrawal.frmtitle1')">
            <template #label>
              <van-field
                type="number"
                v-model="value"
                :placeholder="$t('exchangeb.numerror')"
                :rules="[
                  {
                    required: true,
                  },
                ]"
              >
                <template #extra>
                  <span style="margin-right: 10px">{{ fromitem.title }}</span
                  >|
                  <span
                    style="margin-left: 10px"
                    @click="value = fromitem.balance"
                    >{{ $t("common.all") }}</span
                  >
                </template>
              </van-field>
            </template>
          </van-cell>
          <van-cell :title="$t('withdrawal.frmtitle2')" v-if="safeWapConfig.traders_password_switch == 1">
            <template #label>
              <van-field
                v-model="pwd"
                type="password"
                :placeholder="$t('withdrawal.frmplaceholder2')"
                :rules="[
                  {
                    required: true,
                  },
                ]"
              >
              </van-field>
            </template>
          </van-cell>

          <div style="margin: 16px">
            <van-button class="web-btn" native-type="submit"
              ><van-loading v-if="posting" /><span v-else>{{
                $t("exchangeb.btn")
              }}</span></van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <Footer @hide-header="hideHeader" v-show="!isShowHeader" />
    <van-popup v-model="showPicker" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="title"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showPicker1" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="accountTypes"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onConfirm1"
        @cancel="showPicker1 = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer/index.vue";
export default {
  name: "ChangeB",
  components: { Header,Footer },
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      isShowHeader:true,
      showPicker: false,
      showPicker1: false,
      columns: [],
      posting: false,
      tmp_accountTypes: [
        { value: 2, label: this.$t("assets.tab21") },
        { value: 1, label: this.$t("assets.tab31") },
        { value: 3, label: this.$t("assets.tab41") },
      ],
      accountTypes: [],
      value: null,
      accouttype: {},
      fromitem: {},
      toitem: {},
      ischange: true,
      pwd: null,
    };
  },
  mounted() {
    this.accountTypes = [];
    this.tmp_accountTypes.forEach((element) => {
      if (element.value == 3) {
        if (this.safeWapConfig.quantize_switch == 1) {
          this.accountTypes.push(element);
        }
      } else {
        this.accountTypes.push(element);
      }
    });
    this.onConfirm1(this.accountTypes[0]);
  },
  methods: {
    hideHeader(){
      this.isShowHeader = false
    },
    clickToshow(val){
      this.ischange = val
      this.showPicker = true
    },
    async onSubmit() {
      if (this.posting) return;
      this.posting = true;
      const frm = {
        type: this.accouttype.value,
        from_coin_id: this.fromitem.id,
        to_coin_id: this.toitem.id,
        amount: this.value,
        paypassword: this.pwd,
      };
      await this.$http({
        method: "post",
        url: "exchangeCoin",
        data: frm,
      })
        .then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
          this.value = null;
          this.pwd = null;
          this.getCanExchangeCoin(this.accouttype.value);
        })
        .catch(() => {
          this.posting = false;
        });
    },
    change() {
      const tmp = this.fromitem;
      this.fromitem = this.toitem;
      this.toitem = tmp;
      // this.ischange = !this.ischange;
      this.value = null;
    },
    onConfirm(val) {
      if (!this.ischange) {
        this.toitem = val;
      } else {
        this.fromitem = val;
      }
      this.value = null;
      this.showPicker = false;
    },
    onConfirm1(val) {
      this.accouttype = val;
      this.showPicker1 = false;
      this.getCanExchangeCoin(val.value);
    },
    async getCanExchangeCoin(val) {
      await this.$http({
        method: "post",
        url: "getCanExchangeCoin",
        data: { type: val },
      }).then((res) => {
        this.columns = res.data;
        if (this.columns.length > 1) {
          this.fromitem = this.columns[0];
          this.toitem = this.columns[1];
        }
      });
    },
  },
};
</script>

<style>
</style>
